export const DEFAULT_PAGE_SIZE_OPTIONS = [25, 50, 100];

export const DEFAULT_PAGINATION = DEFAULT_PAGE_SIZE_OPTIONS[0];
